import { StoreActionApi } from 'react-sweet-state';
import { AxiosInstance } from 'axios';

export type TState = {
  loading: boolean;
  stories: IStory[];
};

export type TStoreApi = StoreActionApi<TState>;
export type TContainerProps = { api: AxiosInstance };

export enum StoryStatus {
  PUBLISHED = 1,
  UNPUBLISHED = 2,
};

export enum StoryPrivacy {
  PRIVATE = -1,
  PUBLIC = 1,
};

export enum StoryUnfoldPage {
  ON = 1,
  OFF = -1,
};

export interface IStory {
  brand_uuid: string;
  code: StoryStatus;
  created_at: number;
  link: string;
  privacy: StoryPrivacy;
  story_key: string;
  storySize: number;
  thumbnail: string;
  title: string;
  unfold_page: StoryUnfoldPage;
  updated_at: number;
  uuid: string;
  page_counter: number;
};
